import {Component} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {SafeResourceUrl} from '@angular/platform-browser/src/security/dom_sanitization_service';
import {AppInitService} from '../../app-init.service';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent {
  logo: SafeResourceUrl;
  logoSmall: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer,
    public appInit: AppInitService,
  ) {
    const linkElement = document.createElement('link');
    linkElement.setAttribute('rel', 'icon');
    linkElement.setAttribute('type', 'image/x-icon');
    linkElement.setAttribute('href', this.appInit.customizationConfig.favicon);
    document.head.appendChild(linkElement);

    this.logo = this.sanitizer.bypassSecurityTrustResourceUrl(this.appInit.customizationConfig.logo);
    this.logoSmall = this.sanitizer.bypassSecurityTrustResourceUrl(this.appInit.customizationConfig.logoSmall);
  }
}
